import {WidgetBubble} from "./WidgetBubble";
import React, {useLayoutEffect, useRef} from "react";
import {useAppSelector} from "../../app/hooks";
import {horizontalPositionSelector, welcomeBubbleOpenSelector, WidgetPositionEnum} from "../chatbotSlice";
import {BUBBLE_WIDTH, BUBBLE_WITH_STARTERS_WIDTH} from "./App/App";
import {WelcomeBubble} from "./WelcomeBubble/WelcomeBubble";

interface WidgetBubbleContainerProps {
    resizeWidget: (width: string, height: string) => void;
}

export const WidgetBubbleContainer: React.FC<WidgetBubbleContainerProps> = ({resizeWidget}) => {
    const divRef = useRef(null)
    const isBubbleContentVisible = useAppSelector(welcomeBubbleOpenSelector)
    const bubbleOffsetWidth = isBubbleContentVisible ? BUBBLE_WITH_STARTERS_WIDTH : BUBBLE_WIDTH
    const horizontalPosition = useAppSelector(horizontalPositionSelector)

    useLayoutEffect(() => {
        if (divRef.current === null) {
            return;
        }
        const resizeObserver = new ResizeObserver(entries => {
            for (let entry of entries) {
                const {height} = entry.contentRect;
                // 20px - bottom margin, 20px - welcome bubble image absolute position
                resizeWidget(bubbleOffsetWidth, (height + 20 + 20) + 'px')
            }
        })
        resizeObserver.observe(divRef.current)
        return () => {
            resizeObserver.disconnect();
        };
    }, [isBubbleContentVisible]);


    return <div
            className={`flex flex-col ${horizontalPosition === WidgetPositionEnum.RIGHT ? 'items-end' : 'items-start'} absolute bottom-[20px] right-[20px]`}
            ref={divRef}
            style={{width: 'calc(100% - 30px)'}}>
        {isBubbleContentVisible && <WelcomeBubble/>}
        <WidgetBubble/>
    </div>
}
